import React, { useState, useMemo } from "react";
import uuidv4 from "uuid/v4";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as vendorIntegrationsActionCreators } from "./vendorIntegrations.store";
import { ButtonSizeOptions } from "@loanbossinc/component-library";
import RentCodeItem from "./RentCodeItem";

import { SubHeader, Section, StyledPrimaryButton } from "./styles";

const MriRentCodesSection = (props) => {
  const {
    user,
    rentRollSettings,
    addRentCodeAlias,
    updateRentCodeAlias,
    deleteRentCodeAlias,
  } = props;

  const companyId = user?.contact?.companyId;

  const [tempRentCodeAliases, setTempRentCodeAliases] = useState([]);

  const addTempRentCodeAlias = () => {
    const newTempRentCodeAliases = [...tempRentCodeAliases];
    const codeAlias = {
      id: uuidv4(),
      alias: "",
      chargeCode: "Rent",
      isDefault: false,
    };
    newTempRentCodeAliases.push(codeAlias);
    setTempRentCodeAliases(newTempRentCodeAliases);
  };

  const saveTempRentCodeAlias = ({ index, codeAliasValue }) => {
    const newTempRentCodeAliases = [...tempRentCodeAliases];
    const codeAlias = newTempRentCodeAliases.splice(index, 1)[0];
    setTempRentCodeAliases(newTempRentCodeAliases);
    codeAlias.alias = codeAliasValue;
    codeAlias.temporaryCodeAlias = true;
    addRentCodeAlias({ companyId, codeAlias });
  };

  const cancelTempRentCodeAlias = ({ index }) => {
    const newTempRentCodeAliases = [...tempRentCodeAliases];
    newTempRentCodeAliases.splice(index, 1);
    setTempRentCodeAliases(newTempRentCodeAliases);
  };

  const validCodeAliasCount = useMemo(
    () => rentRollSettings?.rentCodeAliases.filter(
      (code) => !code.temporaryCodeAlias
    ).length,
    [rentRollSettings]
  );

  if (!rentRollSettings) {
    return null;
  }

  return (
    <Section>
      <SubHeader>MRI Rent Codes</SubHeader>
      {rentRollSettings?.rentCodeAliases.map((codeAlias, index) => (
        <RentCodeItem
          key={codeAlias.id}
          index={index}
          companyId={companyId}
          codeAlias={codeAlias}
          codeAliasCount={validCodeAliasCount}
          onCodeAliasSave={updateRentCodeAlias}
          onCodeAliasDelete={deleteRentCodeAlias}
        />
      ))}
      {tempRentCodeAliases.map((codeAlias, index) => (
        <RentCodeItem
          key={codeAlias.id}
          index={index}
          companyId={companyId}
          codeAlias={codeAlias}
          onCodeAliasSave={saveTempRentCodeAlias}
          onCodeAliasCancel={cancelTempRentCodeAlias}
        />
      ))}
      <StyledPrimaryButton
        label="Add"
        onClick={addTempRentCodeAlias}
        size={ButtonSizeOptions.sm}
        style={{
          marginBottom: "1em",
        }}
      />
    </Section>
  );
};

const mapStateToProps = ({ vendorIntegrations, authentication: { user } }) => ({
  ...vendorIntegrations,
  user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...vendorIntegrationsActionCreators }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MriRentCodesSection);
